export default __webpack_public_path__ + "static/media/background.vert.9dcf5ce2.glsl";